<template>

<v-card height="82vh" color="#f9f8ff">
    <v-card-title>
        <div class="stadistic-title">
            <span>RESUMEN</span>
        </div>
    </v-card-title>
        <div class="stadistic-item">
            <span class="stadistic stadistic-item-title ml-5">Monto Total en Deudas</span>
            <span class="stadistic stadistic-item-number ml-5">
                {{ amountTotal | currency('S/') }}
            </span>
        </div>
        <div class="stadistic-item">
            <span class="stadistic stadistic-item-title ml-5">Monto Total Pagado</span>
            <span class="stadistic stadistic-item-number text-green ml-5">
                {{ amountPaid | currency('S/') }}
            </span>
        </div>
        <div class="stadistic-item">
            <span class="stadistic stadistic-item-title ml-5">Monto Pendiente</span>
            <span class="stadistic stadistic-item-number text-red ml-5">
                {{ amountPending | currency('S/') }}
            </span>
        </div>
        <div class="stadistic-item">
            <span class="stadistic stadistic-item-title ml-5">Clientes con deuda</span>
            <span class="stadistic stadistic-item-number ml-5">
                {{ numberCustomers }}
            </span>
        </div>

    <v-card-text>
    </v-card-text>
</v-card>
    
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    name: 'SummaryDebt',
    computed: {
        ...mapState('debts', [
            'amountTotal',
            'amountPaid',
            'amountPending',
            'numberCustomers'
        ])
    }

}
</script>

<style>

</style>